import { toast } from "../components/ui/sonner";
import { getLang } from "./i18n";

/* 签约合同附件「地址一致性」软校验的提示出口（2026-10-16）。
 *
 * 后端在上传接口的响应体里返回 `warnings`（数组，可为空）——**只警告不拦截**。
 * 判定口径见 backend/contract_guard.py：只比门牌号、不比街道名做主判据。
 * 背景：2026-10-16 全站审计发现 3170 Del Vina St 挂了 3150 Muscatel Ave 的合同、
 * CRM 线索 LEAD605a7785 挂了 571 E Hurst St(Covina) 的合同 —— 上传时系统一声不吭，
 * 错挂全靠事后翻账才发现。这里把结果显性化成人能看见的黄色提示。
 *
 * 用法：
 *   const { data } = await api.post(`/crm/signed/${leadId}/contract-file`, {...});
 *   showContractWarnings(data?.warnings);
 */
export function showContractWarnings(warnings, zh) {
  const list = Array.isArray(warnings) ? warnings.filter((w) => w && (w.message || w.messageEn)) : [];
  if (!list.length) return 0;
  const useZh = zh === undefined ? getLang() === "zh" : !!zh;
  list.forEach((w) => toast.warning(useZh ? w.message : (w.messageEn || w.message), { duration: 9000 }));
  return list.length;
}

export default showContractWarnings;
